import Features from "../features/options.js";
import { mapGetters } from "vuex";
import { postAPICall } from "../helpers/httpHelper.js";
// import axios from "@/config/axios";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("companyDocuments", ["getCompanyAllDocuments"]),

    ...mapGetters("documentCategories", ["getAllCategories"]),
    ...mapGetters("documentGroups", ["getAllGroups"]),
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getInitialUrl",
      "getUserSignature",
      "getDefaultDateFormat",
      "getActiveWorkspace",
      "getUserType",
      "getPermissionList",
      "getWorkspaceList",
      "getCompanyPermissionSet",
    ]),
    ...mapGetters("paymentGateway", [
      "getPaymentsHistory",
      "getPlansFeatures",
      "getSubscriptionPlandetails",
    ]),
  },
  async mounted() {
    // let response = await axios.get("/getSubscriptionData");
    // this.$store.commit(
    //   "paymentGateway/setSubscriptionPlanDetails",
    //   response.data.data,
    //   { root: true }
    // );
  },
  methods: {
    getAccessToDashBoardOnlyIfPlanIsInactive() {
      const subscription = this.getSubscriptionPlandetails?.[0];
      if (!subscription || !subscription.plan_details) {
        console.warn("Plan details are missing:", subscription);
        return false;
      }

      const planStatus = subscription.plan_details.status;
      console.log("planStatus:", planStatus);

      return planStatus !== "ACTIVE";
    },
    getAccessToEachFeature(featureKey) {
      if (
        this.getSubscriptionPlandetails &&
        this.getSubscriptionPlandetails[0]?.plan_details?.status === "ACTIVE"
      ) {
        const entityData =
          this.getSubscriptionPlandetails?.[0]?.plan_details?.entityData;
        if (!entityData) return false;
        return Object.values(entityData).some(
          (plan) => plan[featureKey] === "YES"
        );
      }
    },
    async getAccessToEachFeatureWithLimit(moduleName) {
      if (
        this.getSubscriptionPlandetails &&
        this.getSubscriptionPlandetails[0]?.plan_details?.status === "ACTIVE"
      ) {
        if (moduleName) {
          const { data: counts } = await postAPICall(
            "GET",
            `/user/companyUserCount/${this.getActiveWorkspace.company_id}`
          );
          const entityData =
            this.getSubscriptionPlandetails?.[0]?.plan_details?.entityData;
          if (!entityData) return false;
          const isUnlimited =
            Object.values(entityData)[0][`${moduleName}_unlimited`] ||
            Object.values(entityData)[0][`${moduleName}s_unlimited`];
          if (isUnlimited) return true;
          const limit =
            Object.values(entityData)[0][`${moduleName}_limit_per_user`] ||
            Object.values(entityData)[0][`${moduleName}_per_user`];
          if (isNaN(limit)) return false;
          const countKey = `${moduleName}Count`;
          return counts[0][countKey] < limit;
        }
      }
    },
    getAccessToIncludeAi(featureKey) {
      if (
        this.getSubscriptionPlandetails &&
        this.getSubscriptionPlandetails[0]?.plan_details?.status === "ACTIVE"
      ) {
        let entityData =
          this.getSubscriptionPlandetails &&
          this.getSubscriptionPlandetails[0]?.plan_details?.entityData;
        if (!entityData) return false;
        return Object.values(entityData).some((plan) => plan[featureKey]);
      }
    },
    getAccessForFieldTypesInDocuments(type, moduleName) {
      let entityData =
        this.getSubscriptionPlandetails &&
        this.getSubscriptionPlandetails[0]?.plan_details?.entityData;
      if (
        this.getSubscriptionPlandetails &&
        this.getSubscriptionPlandetails[0]?.plan_details?.status === "ACTIVE"
      ) {
        const isUnlimited =
          Object.values(entityData)[0][`${moduleName}_unlimited`] ||
          Object.values(entityData)[0][`${moduleName}s_unlimited`];
        if (isUnlimited) return true;

        if (!entityData) return false;
        let hasFieldType = false;
        Object.values(entityData).forEach((plan) => {
          const types = plan.document_field_type || [];
          if (types.includes(type)) {
            hasFieldType = true;
          }
        });
        return hasFieldType;
      }
    },

    getAccessToIncludeAiInDocuments() {
      //process.env.VUE_APP__SUBSCRIPTION_FREE_TRAIL_PLAN
      if (
        this.getSubscriptionPlandetails &&
        this.getSubscriptionPlandetails[0]?.plan_details?.status === "ACTIVE"
      ) {
        let entityData =
          this.getSubscriptionPlandetails &&
          this.getSubscriptionPlandetails[0]?.plan_details?.entityData;
        if (!entityData) return false;
        let hasFieldType = false;
        Object.values(entityData).forEach((plan) => {
          if (plan.include_ai_in_documents) {
            hasFieldType = true;
          }
        });
        return hasFieldType;
      }
    },

    getAccessForFileSizeType(file) {
      console.log("file", file);
      console.log("getSubscriptionHistory", this.getSubscriptionHistory);
      return true;
    },
    getAccess(typo = "document", accessKey, isField = "") {
      let planName =
        this.getActiveWorkspace && this.getActiveWorkspace.plan_type;
      let plan = planName ? planName.toLowerCase() : "";
      if (Features && Features[plan] && Features[plan][typo]) {
        if (
          isField &&
          Features[plan][typo][isField] &&
          isField &&
          Features[plan][typo][isField][accessKey]
        ) {
          // console.log("true Field Access",Features[plan][typo][accessKey]);
          return Features[plan][typo][isField][accessKey];
        }
        // console.log("true access",Features[plan][typo][accessKey])
        return Features[plan][typo][accessKey];
      } else {
        return false;
      }
    },
    getAccessOfFields(typo = "document", isField = "") {
      let planName =
        this.getActiveWorkspace && this.getActiveWorkspace.plan_type;
      let plan = planName ? planName.toLowerCase() : "";
      if (
        Features[plan] &&
        Features[plan][typo] &&
        Features[plan][typo][isField]
      ) {
        let jsonObject = Features[plan][typo][isField];
        const isAnyKeyTrue = Object.values(jsonObject).some(
          (value) => value === true
        );
        return isAnyKeyTrue;
      } else {
        return false;
      }
    },
    async getAccessToEachFeatureWithUnlimited(moduleName) {
      if (
        this.getSubscriptionPlandetails &&
        this.getSubscriptionPlandetails[0]?.plan_details?.status === "ACTIVE"
      ) {
        if (moduleName) {
          const entityData =
            this.getSubscriptionPlandetails?.[0]?.plan_details?.entityData;
          if (!entityData) return false;
          const isUnlimited =
            Object.values(entityData)[0][`${moduleName}_unlimited`] ||
            Object.values(entityData)[0][`${moduleName}s_unlimited`];
          if (isUnlimited) return true;
          else {
            return false;
          }
        }
      }
    },
  },
  // watch: {
  //   getSubscriptionPlandetails(newVal) {
  //     if (newVal?.length) {
  //       const hasAccess = this.getAccessToDashBoardOnlyIfPlanIsInactive();
  //       console.log("Access to dashboard:", hasAccess);
  //     }
  //   }
  // }
};
